import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { RoutableLink } from '../../react/RoutableLink';
import { Button } from '../../react/Button';
import { Sizes } from '../../ts/enums';
import css from './index.module.scss';

const HeadlineTextBold = ({ fields }) => {
  const additionalCSS = fields?.additionalCSSClasses?.value ? fields.additionalCSSClasses.value : ''; 
  return (
    <section className={`${css.container} single-col-inner ${additionalCSS} `} data-alignment={fields?.alignment?.fields?.align?.value}>
      {
        fields?.heading?.value &&
        <Text field={fields?.heading} tag='h2' className={css.title} />
      }
      {
        (fields?.teaser?.value || (fields?.link?.value?.href && fields?.linkText?.value)) &&
        <div className={css.textContainer}>
          {
            fields?.teaser?.value &&
            <Text field={fields.teaser} tag='p' className={css.teaser}/>
          }
          {
            (fields?.link?.value?.href && fields.linkText?.value) &&
            <RoutableLink field={fields?.link} className={css.link} >
              <Button size={Sizes.SMALL}>
                <Text field={fields?.linkText} />
              </Button>
            </RoutableLink>
          }
        </div>
      }
    </section>
  );
}

export default HeadlineTextBold;